export default "__VITE_ASSET__7WsK35jU__"